import React, { useEffect, useState, useContext } from 'react';
import NoteContext from '../context/note/NoteContext.js';

const Admin = (props) => {
    const [userData, setUserData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const context = useContext(NoteContext);
    const { deleteUser, textColor, backgroundColor } = context;

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await fetch(`${props.URI}/api/auth/getUserAdmin`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "auth-token": localStorage.getItem("token"),
                    },
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const json = await response.json();
                // console.log(json);

                // Check if the response is an object and convert to array
                setUserData(Array.isArray(json) ? json : [json]);
            } catch (error) {
                setError('Error fetching user data: ' + error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);

    const handleDelete = async (userId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this User?");
        if (!isConfirmed) {
            return;
        }
        
        try {
            await deleteUser(userId);
            setUserData(prevData => prevData.filter(user => user._id !== userId));
            props.showAlert("success", "User Deleted Successfully");
        } catch (error) {
            console.error("Error deleting user:", error);
            props.showAlert("error", "Failed to delete user");
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div className='container'>
        <div className='row my-3' style={textColor}>
            <h3 className="text-center mb-4">Admin Panel</h3>

            <div className="container mx-2">
                {userData.length === 0 ? (
                    <p className="text-muted text-center">No Users to Display</p>
                ) : null}
            </div>

            {userData.map((user) => (
                <div className='container col-md-3 mb-4' key={user._id}>
                    <div className="card shadow-sm border">
                        <div className="card-body" style={{...backgroundColor, ...textColor}}>
                            <div className="d-flex justify-content-between align-items-center">
                                <h5 className="card-title mb-0">Name: <strong>{user.name}</strong></h5>
                                <i
                                    className="fa-regular fa-trash-can text-danger cursor-pointer"
                                    onClick={() => { handleDelete(user._id); }}
                                    aria-label="Delete User"
                                ></i>
                            </div>
                            <p className="card-text">Email: <strong>{user.email}</strong></p>
                            <p className="card-text">Admin: <strong>{user.admin ? 'Yes' : 'No'}</strong></p>
                            <p className="card-text">User ID: <strong>{user._id}</strong></p>
                            <p className="card-text">TimeStamp: <strong>{user.timeStamp}</strong></p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
        </div>


    );
};

export default Admin;
